module.exports = function getResource(label) {
    const resources = { saveToMyAccountCheckbox: 'Save to my account' };

    return resources[label];
};
